import { render, staticRenderFns } from "./UploadPoAttachment.vue?vue&type=template&id=063dc026"
import script from "./UploadPoAttachment.vue?vue&type=script&lang=js"
export * from "./UploadPoAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports